import React, { Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import Moment from 'moment';
import ProcessingActivity from '../activity-proccessing/processing-activity';
import { Common } from '../../../../core/common';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import { connect } from 'react-redux';
import { IAppState, IAction } from '../../../../models/action/core';
import { enrollmentStatus } from '../../../../models/enums/enrollmentStatus';
import { enrollmentAddActionLog } from '../../../../store/actions/enrollment';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { Log } from 'ng2-logger';
import HeaderOptions from '../../../../pages/main-navigation/header-options';
import { ActivityTypeEnums, ActivityType } from '../../../../models/enums/ActivityType';
import { SelectAsync } from '../../../input/select/main';
import { UserType } from '../../../../models/enums/userType';
import * as Actions from '../../../../store/actions/coursePage';
import { saveGroupIdToStore } from '../../../../store/actions/assignment';
import Loading from '../../../loading/loading';
import { Guid } from 'guid-typescript';
import { CourseContentMenuType } from '../../../../models/enums/CourseContentMenuType';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import EdiText from 'react-editext';
import { CoursePageService } from '../../../../api/course-page-service';
import { getCourseContentsWeekActivitiesAction } from '../../../../store/actions/coursePage';
import ProgressCircleStudent from '../../../progress-circle/progress-circle-student';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('Project ActivityCard');
const maxEditTextLength = 65;
let getActivityId: string;
const coursePageService = new CoursePageService();

interface IProjectActivityCardState {
    redirect: boolean;
    redirectUrl: string;
    activityFiles: IFiles[];
    userAssignmentFiles: IFiles[];
    projectType: IProjectTypes[];
    styleBackground: string;
    selectKey: string;
    contextId: string;
    editTextValue: string;
    editTextHandleValue: string;
}

interface IFiles {
    fileName: string;
    filePath: string;
    size: string;
}

interface IProjectTypes {
    activityType: any;
    projectActivityId: string;
    hasActivity: boolean;
    deadline: Date;
    color: string;
    isCompleted: boolean;
}

const _danger = '#dc3545';
const _success = '#28a745';
const _empty = '#6c757d';
class ProjectActivityCard extends React.Component<ISignleActivityCard, IProjectActivityCardState> {
    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
        getActivityId = this.props.activityCard!.activityId!;
        this.state = {
            redirect: false,
            redirectUrl: '/',
            activityFiles: [{ fileName: '', filePath: '', size: '' }],
            userAssignmentFiles: [{ fileName: '', filePath: '', size: '' }],
            projectType: [{ activityType: -1, projectActivityId: '', hasActivity: false, deadline: new Date(), color: '', isCompleted: false }],
            styleBackground: '',
            selectKey: Guid.create().toString(),
            contextId: '0',
            editTextValue:
                this.props.activityCard!.name!.toString().length > maxEditTextLength
                    ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                    : this.props.activityCard!.name!.toString(),
            editTextHandleValue: this.props.activityCard!.name!.toString()
        };
        this.afterSave = this.afterSave.bind(this);
    }

    componentDidMount() {
        this.getProjectType();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.activityCard!.projectSubActivity !== prevProps.activityCard.projectSubActivity) {
            this.getProjectType();
        }

        if (this.props.activityCard!.activityId !== prevProps.activityCard.activityId) {
            this.setState({ selectKey: Guid.create().toString(), contextId: '0' }, () => { this.getProjectType(); });
            this.props.dispatch(saveGroupIdToStore('0'));
        }
    }

    public clickViewComplete = () => {
        if (
            ((this.props.activityCard!.enrollmentStatus &&
                this.props.activityCard!.enrollmentStatus !== enrollmentStatus.Completed) || !this.props.activityCard!.enrollmentStatus) &&
            this.props.activityCard!.completionType === ActivityCompletionType.View) {
            this.props.dispatch(
                enrollmentAddActionLog({
                    ActivityCompletionType: ActivityCompletionType.View,
                    ActivityId: this.props.activityCard!.activityId!,
                    EnrollmentId: this.props.activityCard!.enrollmentId!,
                    ClassId: this.props.classId
                })
            );
        }
    };

    public clickToDownload = (event: any) => {
        if (event.currentTarget) {
            const filepath = event.currentTarget.getAttribute('data-filepath').toString();
            const fileName = event.currentTarget.getAttribute('data-filename').toString();

            if (filepath && fileName) {
                _common.DownloadLink(filepath + '/download', fileName);
            }
        }
    };

    targetsOnClick = () => {
        $('#' + 'targets').slideToggle();
    };

    triggerActivityTab = (activityIndex: number) => {
        $('#activity-tab-' + activityIndex).slideToggle();
    };

    getProjectType = () => {
        const updatedProjectType: IProjectTypes[] = [];
        this.props.activityCard!.projectType &&
            this.props.activityCard!.projectType.map(type => {
                let _color = type.isCompleted ? _success : _danger

                updatedProjectType.push({
                    activityType: ActivityTypeEnums[type.activityType],
                    projectActivityId: type.hashedProjectActivityId,
                    hasActivity: false,
                    deadline: type.deadline,
                    color: this.state.contextId === '0' && this.props.userType !== UserType.Student ? _empty : _color,
                    isCompleted: type.isCompleted
                });
            });

        this.setState((prevState: any) =>
        ({
            ...prevState,
            projectType: updatedProjectType
        })
        );
    };

    getSubActivities = (contextId: any) => {
        if (this.props.activityCard!.isGroupProject) {
            this.props.dispatch(saveGroupIdToStore(contextId));
        }

        contextId ? this.setState({ contextId }) : this.setState({ contextId: '0' });

    };

    afterSave() {
        this.props.dispatch(getCourseContentsWeekActivitiesAction(
            this.props.coursePageClassId ? this.props.coursePageClassId : '0',
            this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
            this.props.weekOrUnitId !== '0',
            0,
            1000,
            this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
            false,
            false,
            null,
            'contentWeekActivities',
            'get', undefined,this.props.sortKey ?? "-"));
    }

    public handleSave = (name: any) => {
        if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
            this.props.dispatch(
                Actions.SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
            );
            this.setState({
                editTextValue: name.length > maxEditTextLength
                    ? name.slice(0, maxEditTextLength).toString() + '...'
                    : name.toString(), editTextHandleValue: name
            });
        }
    };

    public handleClick(value: string) {
        this.setState({ editTextValue: value });
    };

    checkPrerequisite = () => {
        let isPrerequisiteCompleted = false
        if (this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student) {
            if (this.props.enrollmentData) {
                let prerequisiteActivities = this.props.enrollmentData.filter(f => f.activityId === this.props.activityCard!.prerequisiteActivityId)
                if (prerequisiteActivities.length > 0) {
                    if (prerequisiteActivities[0].status === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                        isPrerequisiteCompleted = true;

                    }
                }

            }
        }
        return isPrerequisiteCompleted;
    }

    renderCardHeader = () => {
        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let activityDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : null;

        return (
            <div className="d-flex justify-content-between">
                <div className="media">
                    <i className="mr-3 material-icons align-middle">{_common.GetMaterialActivityIcons(ActivityType.Project)}</i>
                    <div className="media-body">
                        {
                            Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ? (
                                <EdiText
                                    type="text"
                                    onSave={this.handleSave}
                                    onCancel={event => this.handleClick(this.state.editTextValue.length > maxEditTextLength
                                        ? this.state.editTextValue.slice(0, maxEditTextLength).toString() + '...'
                                        : this.state.editTextValue.toString())}
                                    onEditingStart={event => this.handleClick(this.state.editTextHandleValue)}
                                    value={this.state.editTextValue}
                                    showButtonsOnHover={true}
                                    saveButtonClassName="hideEditextSaveButton"
                                    cancelButtonClassName="hideEditextCancelButton"
                                    validationMessage={T.t('r_forum_tree_character')}
                                    // tslint:disable-next-line:jsx-no-lambda
                                    validation={val => val.trim().length >= 3}
                                    editOnViewClick={true}
                                    submitOnEnter={true}
                                    cancelOnEscape={true}
                                    className={'font-weight-bold'+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
                                    tabIndex={0}
                                />
                            ) : <h2 className={(!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>{this.props.activityCard!.name}</h2>
                        }
                        {this.props.activityCard!.beginDate ? (
                            <div className="activity-time">
                                <label>{T.t('r_activity_begin_date')}</label>&nbsp;
                                <span>
                                    {Moment(this.props.activityCard!.beginDate).format(_common.GetDateFormatFromPrefrences(this.props.userPreferences!))}
                                </span>
                                &nbsp;-&nbsp;
                                <label> {T.t('r_activity_due_date')}</label>
                                &nbsp;
                                <span>
                                    {Moment(this.props.activityCard!.endDate).format(_common.GetDateFormatFromPrefrences(this.props.userPreferences!))}
                                </span>
                            </div>
                        ) : ''}
                    </div>
                </div>
                <div className="icon-bar d-flex justify-content-between">
                    <div className="dropdown dropleft mr-2">
                        <ProcessingActivity
                            activityId={this.props.activityCard!.activityId}
                            activityType={this.props.activityCard!.activityType}
                            isProjectActivity={true}
                        />
                    </div>
                    {this.props.userType === UserType.Student ? (
                        <ProgressCircleStudent enrollmentStatus={activityEnrollmentStatus ?? enrollmentStatus.NotStarted} deadline={activityDeadline} activityCard={this.props.activityCard} />
                    ) : (
                        ''
                    )}
                    &nbsp;

                    <HeaderOptions
                        projectTypes={this.props.activityCard!.projectType}
                        isProjectActivity={true}
                        projectActivityId={this.props.activityCard!.activityId}
                        activityCard={this.props.activityCard}
                        isGroupProject={this.props.activityCard!.isGroupProject}
                    />
                </div>
            </div>
        )
    }

    renderFooter = (isCompletedPrerequisiteActivity: boolean) => {
        return (
            !isCompletedPrerequisiteActivity && this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student ? null :
                <div className="activity-footer d-flex justify-content-between">
                    {this.props.userType === UserType.Teacher && (
                        <div className="form-input form-group mb-0" style={{ width: '50%' }}>
                            {
                                <SelectAsync
                                    key={this.state.selectKey}
                                    isMulti={false}
                                    isSearchable={true}
                                    requestType={'post'}
                                    parameter={{
                                        Skip: 0,
                                        Take: 10,
                                        GetTypes: this.props.activityCard!.isGroupProject ? 'Group' : 'User',
                                        ClassId: this.props.coursePageClassId,
                                        ActivityId: this.props.activityCard!.activityId
                                    }}
                                    placeHolder={this.props.activityCard!.isGroupProject ? T.t('r_select_group') : T.t('r_select_user')}
                                    url={'api/organization/search'}
                                    closeMenuOnScroll={false}
                                    closeMenuOnSelect={true}
                                    name={'targets'}
                                    hasLocalization={true}
                                    // tslint:disable-next-line: jsx-no-lambda
                                    onChange={(e: any) => this.getSubActivities(e.value)}
                                    isClearable={true}
                                />
                            }
                            <span className="highlight" />
                            <span className="bar" />
                        </div>
                    )}
                    {this.props.coursePageClassId && Common.HasPermission(
                        SecurityContextType.Class,
                        SecurityPermissionType.Activity_Complete,
                        this.props.coursePageClassId
                    ) && (
                            <div className="mini-btn">
                                {this.props.activityCard!.enrollmentStatus &&
                                    this.props.activityCard!.enrollmentStatus === enrollmentStatus.Completed &&
                                    this.props.activityCard!.completionType === ActivityCompletionType.View ? (
                                    <button type="button" className="btn btn-gray mt-md-0 mt-2 mb-md-0 mb-2" disabled={true}>
                                        <i className="material-icons mr-2 icon-rtl">done</i>
                                        {T.t('r_fileUpload_complete')}
                                    </button>
                                ) : (
                                    ''
                                )}

                                {(((this.props.activityCard!.enrollmentStatus &&
                                    this.props.activityCard!.enrollmentStatus !== enrollmentStatus.Completed) || !this.props.activityCard!.enrollmentStatus) &&
                                    this.props.activityCard!.completionType === ActivityCompletionType.View) ? (
                                    <button
                                        type="button"
                                        onClick={this.clickViewComplete}
                                        className="btn btn-green mt-md-0 mt-2 mb-md-0 mb-2"
                                    >
                                        {T.t('r_complete')}
                                    </button>
                                ) : (
                                    ''
                                )}
                            </div>
                        )}
                </div>
        )

    }

    public render() {
        let isCompletedPrerequisiteActivity: boolean = this.checkPrerequisite();

        return (
            <div>
                <div className="col-lg-8 pl-0" style={{ paddingRight: '10px' }}>
                    <Loading spinnerId={'projectSubActivities'} width={100} top={'20%'} />
                    <div className="activity-card activity-exam-card ml-0">
                        <div className={"activity-title "+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')}>
                            {this.renderCardHeader()}
                            {this.props.activityCard!.projectType && this.props.activityCard!.projectType.length > 0 && (
                                <div className="d-flex justify-content-between m-t-b-15">
                                    <div className="media" onClick={this.targetsOnClick} style={{ cursor: 'pointer' }}>
                                        <div className="media-body">
                                            <div className="activity-time back-gray p-5-10 h-30">
                                                <label>{T.t('r_gen_targets')}</label>{' '}
                                                <i className="m-0 material-icons align-middle l-h-1">keyboard_arrow_down</i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="d-flex justify-content-between w-100 m-b-15">
                                {this.props.activityCard!.projectType && (
                                    <div id="targets" className="targets w-100 back-gray p-5-10">
                                        {this.state.projectType.map(
                                            (type: any, typeIndex: any) =>
                                                type.projectActivityId !== '' && (
                                                    <span key={type.projectActivityId } className="ticket p-5-10" style={{ background: type.color }}>
                                                        {T.t('r_activity_type_' + type.activityType)}
                                                        <label>
                                                            <div style={{ float: 'left' }}>{Moment(type.deadline).format('LLLL')}</div>
                                                            <div className="ml-3" style={{ float: 'left' }}>
                                                                {
                                                                    <i
                                                                        style={{ fontSize: '17px', lineHeight: 1 }}
                                                                        className="material-icons"
                                                                    >
                                                                        {type.color === _success && <>done</>}
                                                                        {type.color === _danger && <>clear</>}
                                                                        {type.color === _empty && <>schedule</>}
                                                                    </i>
                                                                }
                                                            </div>
                                                        </label>
                                                    </span>
                                                )
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        {!isCompletedPrerequisiteActivity && this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student ?
                            <div className='row' style={{
                                opacity: 0.5,flexDirection:'column',
fontSize:'1em !important',

                                alignItems:'center',
                                justifyContent:'center',
                                textAlign: 'center',
                            }}>
                                <i className="material-icons" style={{ fontSize: '96px', marginTop: '10px' }}>lock</i>
                                <h5 className="font-medium">
                                    {T.t('r_activity_restriction_by_another_message').replace('{0}', this.props.activityCard!.name).replace('{1}', this.props.activityCard!.prerequisiteActivityName)}
                                </h5>
                            </div> :
                            <div className="activity-body">
                                <p id='instructor_note' className={ (!_common.isArabic(this.props.activityCard!.description!) ? 'left-text' : '')}  dangerouslySetInnerHTML={{ __html: this.props.activityCard!.description! }} />
                                {this.props.activityCard!.file &&
                                    this.props.activityCard!.file.length > 0 &&
                                    this.props.activityCard!.file.map((file, i) => (
                                        <>
                                            <h3>{T.t('r_activity_attachments')}</h3>
                                            <button key={file.fileId} className="file-name w-100 bg-white mb-2">
                                                <i className="material-icons">attach_file</i>
                                                <button
                                                    onClick={this.clickToDownload}
                                                    data-filepath={file?.filePath}
                                                    data-filename={file?.fileName}
                                                    style={{ border: 'none', background: 'none', textAlign: 'start' }}
                                                >
                                                    {file.fileName}
                                                </button>
                                                <span className="ml-auto">{_common.BytesToSize(file ? parseInt(file.size, 10) : 0)}</span>
                                                <br />
                                            </button>
                                        </>
                                    ))}

                                {this.state.userAssignmentFiles &&
                                    this.state.userAssignmentFiles.length > 0 &&
                                    this.state.userAssignmentFiles[0].filePath && (
                                        <>
                                            <h3 className="mt-3 mb-2">{T.t('r_files_my_upload')}</h3>
                                            <div className="upload-files-name">
                                                {this.state.userAssignmentFiles.map((file: any, fileIndex: any) => (
                                                    <button
                                                        key={file.fileId}
                                                        className="file-name w-100 mb-2"
                                                        onClick={this.clickToDownload}
                                                        data-filepath={file?.filePath}
                                                        data-filename={file?.fileName}
                                                    >
                                                        <i className="mr-1 material-icons" style={{ verticalAlign: 'middle' }}>
                                                            attach_file
                                                        </i>
                                                        {file.fileName}
                                                        <span style={{ verticalAlign: 'inherit', marginLeft: '8px', marginTop: '2px' }}>
                                                            {_common.BytesToSize(file ? parseInt(file.size, 10) : 0)}
                                                        </span>
                                                    </button>
                                                ))}
                                            </div>
                                        </>
                                    )}
                            </div>
                        }
                        {
                            this.renderFooter(isCompletedPrerequisiteActivity)
                        }
                    </div>
                </div>

                {!isCompletedPrerequisiteActivity && this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student ? null :
                    this.props.activityCard!.projectSubActivity && this.props.activityCard!.projectSubActivity.length > 0 && (
                        <>
                            {this.props.activityCard!.projectSubActivity.map((activity, activityIndex) => (
                                <div key={activity.activityId}>
                                    <div className="col-lg-8 pl-0 pr-2" style={{ paddingRight: '10px' }}>
                                        <div className="activity-card mb-2 ml-0 pt-3 pb-3">
                                            <div className="activity-title">
                                                <div className="d-flex justify-content-between">
                                                    <button
                                                        className="media"
                                                        style={{ cursor: 'pointer', border: 'none', background: 'none' }}
                                                        onClick={this.triggerActivityTab.bind(this, activityIndex)}
                                                    >
                                                        <div className="activity-circle back-red">
                                                            <i className="material-icons">
                                                                {_common.GetMaterialActivityIcons(activity.activityType)}
                                                            </i>
                                                        </div>
                                                        <div className="media-body" style={{ margin: 'auto' }}>
                                                            <h2>{activity.name}</h2>
                                                        </div>
                                                    </button>
                                                    <div className="icon-bar d-flex justify-content-between">
                                                        <div className="dropdown dropleft">
                                                            <ProcessingActivity
                                                                activityId={activity.activityId}
                                                                activityType={activity.activityType}
                                                                projectActivityId={this.props.activityCard!.activityId}
                                                                isProjectSubActivity={true}
                                                                activityCardItems={activity}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="activity-tab" style={{ display: (this.props.courseContentMenuType === CourseContentMenuType.week ? 'none' : 'block') }} id={'activity-tab-' + activityIndex}>
                                        {this.props.getActivityCardComponent(activity.activityType, activity)}
                                    </div>
                                </div>
                            ))}
                        </>
                    )}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        userPreferences: state.profile.userPreferences.preferences,
        enrollmentData: state.enrollment.enrollmentData,
        userType: state.login.identitiy.userType,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        sortKey: state.coursePage.courseSortingKey
    });

    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.coursePage.courseContentMenuType === prev.coursePage.courseContentMenuType &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities

    );
    return ret;
};


const CProjectActivityCard = connect(
    mapStateToProps,
    dispatchProps, null, { areStatesEqual }
)(ProjectActivityCard);

export default CProjectActivityCard;
